// Zendesk


export default {
    init() {

        zE(function () {
            zE.setLocale('fr');

            if (window.GrandsEspaces.user) {
                zE.identify({
                    name: window.GrandsEspaces.user.displayName,
                    email: window.GrandsEspaces.user.email
                });
            }


        });


        window.zESettings = {
            webWidget: {
                color: {
                    theme: '#144173',
                    launcherText: '#F0F3F7',

                },
                launcher: {
                    chatLabel: { // Quand le chat agent est actif
                        'fr': 'Besoin d\'aide ?',
                        '*': 'Chat now sd'
                    },
                    label: { // Quand le chat agent n'est pas actif
                        'fr': 'Besoin d\'aide ?'
                    },
                    chatButton: {
                        'fr': 'Discutez avec une personne',
                        '*': 'Chat with a person now'
                    }
                },
               contactForm: {
                    // fields: [
                    //     {id: 'description', prefill: {'*': 'Votre message ici'}},
                    //     {id: 'telephone', prefill: {'*': 'Téléphone user'}},
                    //     {id: 360012802071, prefill: {'*': 'Téléphone ticket'}},
                    //     {id: 2142225, prefill: {'*': 'My custom field text'}}
                    // ],
                    attachments: false
                },
                contactOptions: {
                    enabled: false,
                    contactFormLabel: {'*': 'Leave us a message','fr': 'Laissez nous un message',}
                }
            }
        };


    },


};






// WEBPACK FOOTER //
// ./assets/js/libs/Zendesk.js